 // <!-- HC - Custom scripts - 27 June '23 -->
// Scroll to top button
var btn = $('#button-up');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});
  
btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});    

/* HC - Collection Template - Infinite Loading - 03 July '23 */
$(window).on('scroll', function(e) {
  const scrollTop = $(window).scrollTop();
  $('body').hasClass('loading-products') ? $('.loading').show() : $('.loading').hide();
  if($('#more-link').length && !$('body').is('.loading-products')) {
    target = $('#more-link').offset().top;
    if(scrollTop => target) fetchNewProducts();
  }
});

const fetchNewProducts = function() {
  const more = $('#more-link');
  const url = more.attr('href');
  const productsContainer = 'ul.grid.grid--uniform.grid--view-items'; // PRODUCT CONTAINER CLASS HERE
  const productItems = 'li.grid__item.grid__item--collection-template.small--one-half.medium-up--one-quarter'; // PRODUCT WRAPPER CLASS HERE
  
  $.ajax({
    url,
    beforeSend: function() {
      $('body').addClass('loading-products');
    },
    datatype: 'html',
    method: 'get',
    success: function(data) {
      const newMore = $(data).find('#more-link').attr('href');
      const newProducts = $(data).find(productItems);
      
      $(productsContainer).append(newProducts);
      
      newMore ? more.attr('href', newMore) : more.remove();
      $('body').removeClass('loading-products');
    },
    error: function(message) {
       console.error(message)
    }
  });
};

//  <!-- HC - Featured section slider and promo grid slider - 13 July '23 -->

$(document).ready(function () {

 
$('.featured-collection .grid').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718 "/></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "/></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
});

});

function resizeSlider() {
  var slickHeight = $(".promo-grid .flex-grid.main-grid-wrap .slick-track").outerHeight();

  $(".promo-grid .flex-grid.main-grid-wrap .slick-track")
    .find(".slick-slide")
    .css("height", slickHeight + "px");
}
$('.promo-grid .flex-grid.main-grid-wrap').slick({
  dots: false,
  arrows: true,
  infinite: false,
  mobileFirst: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718 "/></svg></button>',
  nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "/></svg></button>',
  responsive: [
    {
      breakpoint: 769,
      settings: "unslick"
    }
  ]
}).on("setPosition", function () {
    resizeSlider();
});

$(window).on("resize", function (e) {
  resizeSlider();
});
